"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPublishedMarketingCardsNew = void 0;
class GetPublishedMarketingCardsNew {
    constructor(marketingCardService) {
        this.marketingCardService = marketingCardService;
    }
    execute(request) {
        return this.marketingCardService.getPublishedMarketingCardsNew(request);
    }
}
exports.GetPublishedMarketingCardsNew = GetPublishedMarketingCardsNew;
